<template>
    <div v-loading="loader" class="edit-product container-fluid">
        <div class="activity-last-updated float-right">
            <span v-if="product.shop_id"
            >&nbsp;
                <a :href="product.shop_url" target="_blank"
                ><i class="fe fe-globe"></i
                ></a>
            </span>
            <i class="fe fe-file-plus"></i>
            <strong>{{ product.created_user_at_human }}</strong> -
            <em>{{ product.author_creation }}</em> | <i class="fe fe-edit"></i>
            <strong>{{ product.updated_user_at_human }}</strong> -
            <em>{{ product.author_modification }}</em> |
            <i class="fe fe-refresh-cw"></i>
            <strong>{{ product.syncronized_at_human }}</strong> -
            <em>{{ product.author_synchronization }}</em>
        </div>
        <div class="clearfix"></div>
        <div v-if="invalidDescription">
            <div class="alert alert-danger" role="alert">
                Merci de corriger la description elle ne doit pas contenir de
                <strong>style</strong> ou de
                <strong>class</strong>
            </div>
        </div>
        <el-form
            v-if="product.id"
            ref="productForm"
            :model="product"
            :rules="rules"
            class="row"
            label-position="top"
        >
            <div class="col-12">
                <el-tabs v-model="activeTab" tab-position="left">
                    <el-tab-pane
                        v-if="user.can('edit product general')"
                        label="Général"
                        name="general"
                    >
                        <div class="ctn-limit-height" data-tabs="general">
                            <el-form-item
                                v-if="user.can('edit product name')"
                                label="Désignation H1"
                                prop="name"
                            >
                                <el-input
                                    v-model="product.name"
                                    @change="copyValue('name')"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                v-if="user.can('edit product short_desc')"
                                label="Description courte"
                                prop="short_desc"
                            >
                                <el-input
                                    v-model="product.short_desc"
                                    rows="4"
                                    type="textarea"
                                ></el-input>
                            </el-form-item>

                            <el-form-item
                                v-if="user.can('edit product description')"
                                label="Nouvelle description ?"
                            >
                                <el-switch
                                    v-model="useNewDescription"
                                    active-text="Oui"
                                    inactive-text="Non"
                                >
                                </el-switch>
                            </el-form-item>

                            <template v-if="useNewDescription === true">
                                <div v-if="isCasque" class="clearfix">
                                    <el-button
                                        class="float-right"
                                        @click="
                                            addCasqueDescriptionSentence(
                                                'description_detailed'
                                            )
                                        "
                                    >
                                        Ajouter "Attention, ce casque est livré
                                        avec une visière incolore."
                                    </el-button>
                                </div>

                                <el-form-item
                                    v-if="user.can('edit product description')"
                                    label="Description (new)"
                                    prop="description_detailed"
                                >
                                    <editor
                                        v-model="product.description_detailed"
                                        :config="editorConfig"
                                    ></editor>
                                </el-form-item>

                                <div class="mb-5">
                                    <label>Descriptif technique</label>
                                    <div
                                        v-for="(
                                            titleDescription, index
                                        ) in product.titleDescriptions"
                                        :key="index"
                                        class="mt-2"
                                    >
                                        <label
                                        ><strong>{{
                                                titleDescription.title
                                            }}</strong></label
                                        >
                                        <p v-if="titleDescription.help">
                                            <small>{{
                                                    titleDescription.help
                                                }}</small>
                                        </p>
                                        <div
                                            v-if="
                                                'sentences' in
                                                    titleDescription &&
                                                titleDescription.sentences
                                                    .length > 0
                                            "
                                            class="d-flex"
                                        >
                                            <button
                                                v-for="sentence in titleDescription.sentences"
                                                class="btn btn-link"
                                                type="button"
                                                @click="
                                                    insertInTitleDescription(
                                                        index,
                                                        sentence
                                                    )
                                                "
                                            >
                                                {{ sentence }}
                                            </button>
                                        </div>
                                        <el-input
                                            v-model="titleDescription.to_add"
                                            placeholder="titre"
                                        >
                                            <template slot="append">
                                                <el-button
                                                    icon="el-icon-plus"
                                                    type="primary"
                                                    @click="addTitle(index)"
                                                ></el-button>
                                            </template>
                                        </el-input>
                                        <draggable
                                            v-model="titleDescription.values"
                                            handle=".handle"
                                        >
                                            <div
                                                v-for="(
                                                    title, indexV
                                                ) in titleDescription.values"
                                                :key="indexV"
                                                class="mt-2"
                                            >
                                                <el-input
                                                    v-model="
                                                        titleDescription.values[
                                                            indexV
                                                        ]
                                                    "
                                                    placeholder="titre"
                                                >
                                                    <template slot="prepend">
                                                        <el-button
                                                            class="handle"
                                                            type="primary"
                                                        >
                                                            <svg
                                                                fill="none"
                                                                stroke="currentColor"
                                                                style="
                                                                    width: 1.5em;
                                                                    height: 1.5em;
                                                                "
                                                                viewBox="0 0 24 24"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                    stroke-width="2"
                                                                />
                                                            </svg>
                                                        </el-button>
                                                    </template>
                                                    <template slot="append">
                                                        <el-button
                                                            icon="el-icon-minus"
                                                            type="primary"
                                                            @click="
                                                                removeTitle(
                                                                    index,
                                                                    indexV
                                                                )
                                                            "
                                                        ></el-button>
                                                    </template>
                                                </el-input>
                                            </div>
                                        </draggable>
                                    </div>
                                </div>
                            </template>

                            <template v-if="useNewDescription === false">
                                <div class="mb-5">
                                    <el-form-item
                                        v-if="
                                            user.can('edit product description')
                                        "
                                        label="Description (old)"
                                        prop="description"
                                    >
                                        <editor
                                            v-model="product.description"
                                            :config="editorConfig"
                                        ></editor>
                                    </el-form-item>
                                    <el-form-item
                                        v-if="
                                            user.can(
                                                'edit product technical_desc'
                                            )
                                        "
                                        label="Descriptif technique (1 par ligne)"
                                        prop="string_technical_desc"
                                    >
                                        <el-input
                                            v-model="
                                                product.string_technical_desc
                                            "
                                            rows="4"
                                            type="textarea"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </template>

                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product description'
                                                )
                                            "
                                            label="Avantages du produit"
                                            prop="avantages"
                                        >
                                            <editor
                                                v-model="product.avantages"
                                                :config="editorConfig"
                                            ></editor>
                                        </el-form-item>
                                    </div>
                                    <div class="col">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product description'
                                                )
                                            "
                                            label="Le conseil Speedway"
                                            prop="conseil"
                                        >
                                            <editor
                                                v-model="product.conseil"
                                                :config="editorConfig"
                                            ></editor>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>

                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-6">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product sale_autorized'
                                                )
                                            "
                                            class="m-0"
                                            prop="sale_autorized"
                                        >
                                            <el-checkbox
                                                v-model="product.sale_autorized"
                                            >Authorisé à la vente
                                            </el-checkbox>
                                        </el-form-item>
                                        <el-form-item
                                            class="m-0"
                                            prop="no_image"
                                        >
                                            <el-checkbox
                                                v-model="product.no_image"
                                            >Sans image
                                            </el-checkbox>
                                        </el-form-item>
                                        <el-form-item prop="checkbox">
                                            <el-checkbox
                                                v-if="
                                                    user.can(
                                                        'edit product indexed'
                                                    )
                                                "
                                                v-model="product.indexed"
                                            >Indéxé
                                            </el-checkbox>
                                            <el-checkbox
                                                v-if="
                                                    user.can(
                                                        'edit product activated'
                                                    )
                                                "
                                                v-model="product.activated"
                                            >Activé
                                            </el-checkbox>
                                        </el-form-item>
                                    </div>
                                    <div class="col-3">
                                        <el-form-item
                                            v-if="
                                                user.can('edit product ecotax')
                                            "
                                            label="EcoTax"
                                            prop="ecotax"
                                        >
                                            <el-input-number
                                                v-model="product.ecotax"
                                                :min="0"
                                                controls-position="right"
                                            ></el-input-number>
                                        </el-form-item>
                                    </div>
                                    <div class="col-6">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product date_new'
                                                )
                                            "
                                            label="Date de nouveauté"
                                            prop="date_new"
                                        >
                                            <el-date-picker
                                                v-model="product.date_new"
                                                format="dd/MM/yyyy"
                                                placeholder="Choisissez une date"
                                                type="date"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                            >
                                            </el-date-picker>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product youtube_video'
                                                )
                                            "
                                            label="ID video Youtube"
                                            prop="youtube_video"
                                        >
                                            <el-input
                                                v-model="product.youtube_video"
                                                type="url"
                                            >
                                            </el-input>
                                        </el-form-item>
                                        <iframe
                                            v-if="product.youtube_video"
                                            :src="
                                                'https://www.youtube.com/embed/' +
                                                product.youtube_video
                                            "
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen
                                            frameborder="0"
                                            height="158"
                                            width="290"
                                        ></iframe>
                                    </div>
                                    <div class="col-6">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product condition'
                                                )
                                            "
                                            label="État"
                                            prop="condition"
                                        >
                                            <el-select
                                                v-model="product.condition"
                                                placeholder="État"
                                            >
                                                <el-option
                                                    v-for="item in conditionOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="user.can('edit product general')"
                        label="Prix"
                        name="prix"
                    >
                        <div class="ctn-limit-height" data-tabs="general">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-2">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product mf_price_public'
                                                )
                                            "
                                            label="Prix de vente HT"
                                            prop="mf_price"
                                        >
                                            <el-input-number
                                                v-model="
                                                    product.mf_price_public
                                                "
                                                :min="0"
                                                controls-position="right"
                                            ></el-input-number>
                                            <p class="font-weight-bold">
                                                Soit
                                                {{ this.mf_public_price_ttc }}€
                                                ttc
                                            </p>
                                        </el-form-item>
                                    </div>
                                    <div class="col-2">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product mf_price_public'
                                                )
                                            "
                                            label="Prix Speedway HT"
                                            prop="price_speedway"
                                        >
                                            <el-input-number
                                                v-model="product.price_speedway"
                                                :min="0"
                                                controls-position="right"
                                            ></el-input-number>
                                            <p class="font-weight-bold">
                                                Soit
                                                {{ this.price_speedway_ttc }}€
                                                ttc
                                            </p>
                                        </el-form-item>
                                    </div>
                                    <div class="col-2">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product mf_price_public'
                                                )
                                            "
                                            label="Prix d'achat HT"
                                            prop="paht"
                                        >
                                            <el-input-number
                                                v-model="product.paht"
                                                :min="0"
                                                controls-position="right"
                                            ></el-input-number>
                                        </el-form-item>
                                        Taux de marge : {{ txMarge }}
                                    </div>
                                    <div v-if="product.new_price" class="col-2">
                                        <div
                                            class="alert alert-info"
                                            role="alert"
                                        >
                                            <p>
                                                Nouveau prix :
                                                {{ product.new_price }}€ TTC
                                            </p>
                                        </div>
                                        <small>PriceObservatory prix</small>
                                    </div>
                                    <template
                                        v-if="user.can('edit product coef')"
                                    >
                                        <div class="col-12">
                                            <label for=""
                                            ><strong
                                            >Coef Fournisseur</strong
                                            ></label
                                            >
                                        </div>
                                        <div class="col-3">
                                            <el-form-item
                                                label="Coef"
                                                prop="override_manufacturer_coeff"
                                            >
                                                <el-input-number
                                                    v-model="
                                                        product.override_manufacturer_coeff
                                                    "
                                                    :max="30"
                                                    :min="0"
                                                    controls-position="right"
                                                ></el-input-number>
                                            </el-form-item>
                                        </div>
                                        <div class="col-3">
                                            <el-form-item
                                                class="m-0"
                                                prop="disallow_coeff_manufacturer"
                                            >
                                                <el-checkbox
                                                    v-model="
                                                        product.disallow_coeff_manufacturer
                                                    "
                                                >Désactiver le coeff
                                                </el-checkbox>
                                            </el-form-item>
                                        </div>
                                    </template>
                                </div>
                                <label for=""
                                ><strong>Popularité</strong></label
                                >
                                <div class="row mb-5 mt-1">
                                    <div class="col-4">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product popularity'
                                                )
                                            "
                                            label="Boost produit"
                                            prop="popularity"
                                        >
                                            <el-input-number
                                                v-model="
                                                    product.popularity.sort_man
                                                "
                                                :min="0"
                                                controls-position="right"
                                            ></el-input-number>
                                        </el-form-item>
                                    </div>
                                    <div class="col-4">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product popularity'
                                                )
                                            "
                                            label="Boost de nouveauté"
                                            prop="popularity"
                                        >
                                            <el-input-number
                                                v-model="
                                                    product.popularity.cpt_new
                                                "
                                                :min="0"
                                                controls-position="right"
                                            ></el-input-number>
                                        </el-form-item>
                                    </div>
                                    <div class="col-4">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product popularity'
                                                )
                                            "
                                            label="Durée nouveauté"
                                            prop="popularity"
                                        >
                                            <el-input-number
                                                v-model="
                                                    product.popularity.cpt_time
                                                "
                                                :min="0"
                                                controls-position="right"
                                            ></el-input-number>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="user.can('edit product associate')"
                        class="ctn-limit-height"
                        label="Association"
                        name="associate"
                    >
                        <div data-tabs="associate">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-6">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product category_id'
                                                )
                                            "
                                            label="Catégorie principale"
                                            prop="category_id"
                                        >
                                            <el-cascader
                                                v-model="product.categories"
                                                :filter-method="filterCascader"
                                                :options="categoriesOptions"
                                                :props="{
                                                    label: 'name',
                                                    value: 'id',
                                                }"
                                                change-on-select
                                                class="full-width"
                                                clearable
                                                filterable
                                            ></el-cascader>
                                        </el-form-item>
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product category_secondary'
                                                )
                                            "
                                            label="Catégories secondaire"
                                            prop="category_secondary"
                                        ></el-form-item>
                                        <div
                                            v-if="
                                                user.can(
                                                    'edit product category_secondary'
                                                )
                                            "
                                            class="row full-width"
                                        >
                                            <div class="col-lg-9">
                                                <el-cascader
                                                    v-model="
                                                        product.category_secondary
                                                    "
                                                    :filter-method="
                                                        filterCascader
                                                    "
                                                    :options="categoriesOptions"
                                                    :props="{
                                                        label: 'name',
                                                        value: 'id',
                                                    }"
                                                    change-on-select
                                                    class="full-width"
                                                    clearable
                                                    filterable
                                                ></el-cascader>
                                            </div>
                                            <div class="col-lg-3">
                                                <button
                                                    class="btn btn-outline-success"
                                                    @click.prevent="
                                                        addTagCategory
                                                    "
                                                >
                                                    Ajouter
                                                </button>
                                            </div>
                                        </div>
                                        <div
                                            v-if="
                                                user.can(
                                                    'edit product category_secondary'
                                                )
                                            "
                                            class="mt-3"
                                        >
                                            <el-tag
                                                v-for="category in product.categories_secondary"
                                                :key="category.id"
                                                class="ml-3 mb-3"
                                                closable
                                                @close="
                                                    removeTagCategory(category)
                                                "
                                            >
                                                {{ category.name }}
                                            </el-tag>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-6">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product brand_id'
                                                )
                                            "
                                            label="Marques"
                                            prop="brand_id"
                                        >
                                            <el-select
                                                v-model="product.brand_id"
                                                filterable
                                                placeholder="Marques"
                                                @change="brandChange"
                                            >
                                                <el-option
                                                    v-for="item in brandsOptions"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="col-6">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product manufacturer_ref'
                                                )
                                            "
                                            label="Ref fabricant"
                                            prop="manufacturer_ref"
                                        >
                                            <el-input
                                                v-model="
                                                    product.manufacturer_ref
                                                "
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-6">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product external_ref'
                                                )
                                            "
                                            label="Ref fournisseur (Logyone)"
                                            prop="external_ref"
                                        >
                                            <el-input
                                                v-model="product.external_ref"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="col-6">
                                        <el-form-item
                                            v-if="
                                                user.can(
                                                    'edit product ref_kwisatz'
                                                )
                                            "
                                            label="Ref Kwisatz"
                                            prop="ref_kwisatz"
                                        >
                                            <el-input
                                                v-model="product.ref_kwisatz"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-6">
                                        <el-form-item
                                            v-if="
                                                user.can('edit product ean13')
                                            "
                                            label="Code barre"
                                            prop="ean13"
                                        >
                                            <el-input
                                                v-model="product.ean13"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-6">
                                        <el-form-item
                                            v-if="
                                                user.can('edit product shop_id')
                                            "
                                            label="Pim Id"
                                            prop="shop_id"
                                        >
                                            {{ product.id }}
                                        </el-form-item>
                                    </div>
                                    <div class="col-6">
                                        <el-form-item
                                            v-if="
                                                user.can('edit product shop_id')
                                            "
                                            label="Shop Id"
                                            prop="shop_id"
                                        >
                                            <el-input
                                                v-model="product.shop_id"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                            <!-- <el-form-item prop="motocloud_ref" label="Ref motocloud">
                                <el-input v-model="product.motocloud_ref"></el-input>
                            </el-form-item> -->
                            <div
                                v-if="user.can('edit product mf_prefixe')"
                                class="row"
                            >
                                <div class="col-lg-6">
                                    <el-form-item
                                        label="Fournisseur"
                                        prop="manufacturer_id"
                                    >
                                        <el-select
                                            v-model="product.manufacturer_id"
                                            filterable
                                            placeholder="Fournisseur"
                                        >
                                            <el-option
                                                v-for="item in manufacturersOptions"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="col-lg-6">
                                    <el-form-item
                                        label="Préfixe fournisseur"
                                        prop="mf_prefixe"
                                    >
                                        <el-input
                                            v-model="product.mf_prefixe"
                                            maxlength="3"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <hr />
                            <p
                                v-if="user.can('edit product images')"
                                class="link"
                                @click="openGalery(product)"
                            >
                                Images
                            </p>
                            <div
                                v-if="user.can('edit product images')"
                                class="row"
                            >
                                <template v-if="product.images.length">
                                    <div
                                        v-for="(image, index) in product.images"
                                        :key="index"
                                        class="col-sm-3 col-lg-2 m-2"
                                    >
                                        <a
                                            href="#"
                                            @click.prevent="openGalery(product)"
                                        >
                                            <img
                                                :alt="image.filename"
                                                :src="'/ic/small/' + image.path"
                                                class="rounded img-product-list"
                                                @click="openGalery(product)"
                                            />
                                        </a>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="user.can('edit product features')"
                        class="ctn-limit-height"
                        label="Features"
                        name="features"
                    >
                        <div data-tabs="features">
                            <label for="">Features</label>
                            <div class="features-list">
                                <!--
                                <el-collapse v-model="collapsFeature">
                                    <el-collapse-item :class="{hasSelected: getFeatureSelectedCount(feature)}" v-for="(feature, i) in featureOptions" :key="i" :title="feature.label+' ('+getFeatureSelectedCount(feature)+')'" :name="feature.value">
                                        <div class="row">
                                            <div class="col-lg-3" v-for="(child, index) in feature.children" :key="index">
                                                <el-checkbox size="mini" v-model="product.featuresIds" :label="child.value" border>{{child.label}}</el-checkbox>
                                            </div>
                                        </div>
                                    </el-collapse-item>
                                </el-collapse>
                                -->
                                <product-edit-features
                                    :product.sync="product"
                                ></product-edit-features>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="user.can('edit product seo')"
                        class="ctn-limit-height"
                        label="SEO"
                        name="seo"
                    >
                        <div data-tabs="seo">
                            <el-form-item
                                v-if="user.can('edit product meta_desc')"
                                label="Meta description"
                                prop="meta_desc"
                            >
                                <el-input
                                    v-model="product.meta_desc"
                                    rows="4"
                                    type="textarea"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                v-if="user.can('edit product meta_title')"
                                label="Balise title"
                                prop="meta_title"
                            >
                                <el-input
                                    v-model="product.meta_title"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                v-if="user.can('edit product slug')"
                                label="URL simplifiée"
                                prop="slug"
                            >
                                <el-input v-model="product.slug">
                                    <template slot="append">
                                        <el-button
                                            icon="el-icon-collection-tag"
                                            @click="generateSlug()"
                                        >Générer
                                        </el-button>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="user.can('edit product stock')"
                        class="ctn-limit-height"
                        label="Stock"
                        name="stock"
                    >
                        <div data-tabs="stock">
                            <el-form-item
                                v-if="user.can('edit product sync_stock')"
                                label="Syncronisation du stock ?"
                            >
                                <el-switch
                                    v-model="product.sync_stock"
                                    active-text="Oui"
                                    inactive-text="Non"
                                ></el-switch>
                            </el-form-item>
                            <el-form-item
                                v-if="user.can('edit product has_stock')"
                                label="En stock ?"
                            >
                                <strong
                                    v-if="product.has_stock"
                                    class="text-success"
                                >Oui</strong
                                >
                                <strong
                                    v-if="!product.has_stock"
                                    class="text-danger"
                                >Non</strong
                                >
                            </el-form-item>
                            <el-form-item
                                v-if="user.can('edit product date_dispo_fourn')"
                                label="Date de disponibilité fournisseur"
                                prop="date_dispo_fourn"
                            >
                                <el-date-picker
                                    v-model="product.date_dispo_fourn"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item
                                v-if="user.can('edit product date_dispo_fourn')"
                                label="Date de disponibilité Speedway"
                                prop="date_dispo_pim"
                            >
                                <el-date-picker
                                    v-model="product.date_dispo_pim"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item
                                v-if="user.can('edit product reapro_type')"
                                label="Type de réappro"
                                prop="reapro_type"
                            >
                                <el-select
                                    v-model="product.reapro"
                                    placeholder="Type de réappro"
                                >
                                    <el-option
                                        v-for="item in reaproOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                v-if="
                                    user.can(
                                        'edit product out_of_stock_message'
                                    )
                                "
                                label="Message si hors stock"
                                prop="out_of_stock_message"
                            >
                                <el-input
                                    v-model="product.out_of_stock_message"
                                    rows="5"
                                    type="textarea"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="user.can('edit product variations')"
                        class="ctn-limit-height"
                        label="Variations"
                        name="variation"
                    >
                        <div data-tabs="variation">
                            <product-variations
                                :product="product"
                                @added="variationAdded"
                                @removed="variationRemoved"
                            ></product-variations>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="user.can('edit product regroupment')"
                        class="ctn-limit-height"
                        label="Regroupement"
                        name="regroupment"
                    >
                        <div data-tabs="regroupment">
                            <product-regroupment
                                :product="product"
                            ></product-regroupment>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="user.can('edit product accessories')"
                        label="Produit recommandé"
                        name="accessories"
                    >
                        <product-accessories
                            :product="product"
                        ></product-accessories>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="user.can('edit product attachment')"
                        class="ctn-limit-height"
                        label="Fichiers"
                        name="attachment"
                    >
                        <div data-tabs="attachment">
                            <product-edit-attachments
                                :product="product"
                            ></product-edit-attachments>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="user.can('edit product general')"
                        class="ctn-limit-height"
                        label="Logistique"
                        name="logistics"
                    >
                        <div data-tabs="logistics">
                            <div class="row">
                                <div class="col-3">
                                    <el-form-item
                                        v-if="user.can('edit product width')"
                                        label="Largeur (cm)"
                                        prop="width"
                                    >
                                        <el-input-number
                                            v-model="product.width"
                                            :min="0"
                                            controls-position="right"
                                        ></el-input-number>
                                    </el-form-item>
                                </div>
                                <div class="col-3">
                                    <el-form-item
                                        v-if="user.can('edit product height')"
                                        label="Hauteur (cm)"
                                        prop="height"
                                    >
                                        <el-input-number
                                            v-model="product.height"
                                            :min="0"
                                            controls-position="right"
                                        ></el-input-number>
                                    </el-form-item>
                                </div>
                                <div class="col-3">
                                    <el-form-item
                                        v-if="user.can('edit product depth')"
                                        label="Profondeur (cm)"
                                        prop="depth"
                                    >
                                        <el-input-number
                                            v-model="product.depth"
                                            :min="0"
                                            controls-position="right"
                                        ></el-input-number>
                                    </el-form-item>
                                </div>
                                <div class="col-3">
                                    <el-form-item
                                        v-if="user.can('edit product weight')"
                                        label="Poids (g)"
                                        prop="weight"
                                    >
                                        <el-input-number
                                            v-model="product.weight"
                                            :min="0"
                                            controls-position="right"
                                        ></el-input-number>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3">
                                    <el-form-item
                                        label="Poids volumétrique (Kg)"
                                    >
                                        <el-input
                                            v-model="volumetricWeight"
                                            disabled
                                        ></el-input>
                                        <small>L x l x h / 5000</small>
                                    </el-form-item>
                                </div>
                                <div class="col-3">
                                    <el-form-item label="Poids (Kg)">
                                        <el-input
                                            v-model="calculatedWeightKg"
                                            disabled
                                        ></el-input>
                                    </el-form-item>
                                </div>
                                <div class="col-3">
                                    <el-form-item label="Développé Colissimo">
                                        <el-input
                                            v-model="developpeColissimi"
                                            disabled
                                        ></el-input>
                                        <small>L + l + h</small>
                                    </el-form-item>
                                </div>
                                <div class="col-3">
                                    <el-form-item label="Développé Chronopost">
                                        <el-input
                                            v-model="developpeChronopost"
                                            disabled
                                        ></el-input>
                                        <small>L + 2l + 2h</small>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3">
                                    <el-form-item
                                        label="HS CODE"
                                        prop="hs_code"
                                    >
                                        <el-input
                                            v-model="product.hs_code"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                                <div class="col-3">
                                    <el-form-item
                                        label="PAYS ORIGINE"
                                        prop="country_origin"
                                    >
                                        <el-select
                                            v-model="product.country_origin"
                                            clearable
                                            filterable
                                            placeholder="Pays d'origine"
                                        >
                                            <el-option
                                                v-for="item in countries"
                                                :key="item.code"
                                                :label="
                                                    item.code +
                                                    ' - ' +
                                                    item.name
                                                "
                                                :value="item.code"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <carrier-selector
                                        v-model="
                                            product.excluded_carrier_reference
                                        "
                                    ></carrier-selector>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="product.review_errors"
                        class="ctn-limit-height error-tabs"
                        label="Attention !"
                        name="warning"
                    >
                        <div data-tabs="warning">
                            <div
                                v-for="(errors, key) in product.review_errors"
                                :key="key"
                            >
                                <div
                                    v-for="(error, keyError) in errors"
                                    :key="keyError"
                                    class="mt-3"
                                >
                                    <strong>{{ error.msg }}</strong>
                                    <span v-if="error.ref"
                                    >({{ error.ref }})</span
                                    >
                                    <span
                                        v-if="
                                            error.value &&
                                            error.value.constructor !== Array
                                        "
                                    >
                                        : {{ error.value }}
                                        <span v-if="error.initialValue"
                                        >({{ error.initialValue }})</span
                                        ></span
                                    >
                                    <div
                                        v-if="
                                            error.value &&
                                            error.value.constructor === Array
                                        "
                                    >
                                        <div
                                            v-for="(el, elKey) in error.value"
                                            :key="elKey"
                                            class="d-flex"
                                        >
                                            <div
                                                v-for="c in Object.keys(el)"
                                                :key="c"
                                                class="ml-2"
                                            >
                                                <strong>{{ c }}</strong> :
                                                {{ el[c] }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="d-flex align-items-center mx-auto">
                <el-form-item class="m-3">
                    <el-button
                        :disabled="invalidDescription"
                        type="primary"
                        @click="updateProduct(false)"
                    >Sauvegarder
                    </el-button>
                </el-form-item>
                <el-form-item class="m-3">
                    <el-button
                        :disabled="invalidDescription"
                        type="primary"
                        @click="updateProduct(false, true)"
                    >
                        Sauvegarder et continuer
                    </el-button>
                </el-form-item>
                <el-form-item class="m-3">
                    <el-button
                        v-if="nextId"
                        :disabled="invalidDescription"
                        type="info"
                        @click="updateProduct(true)"
                    >
                        Sauvegarder et suivant
                    </el-button>
                </el-form-item>
                <el-form-item v-if="user.can('remove product')" class="m-3">
                    <el-button plain type="danger" @click="deleteProduct"
                    >Supprimer
                    </el-button>
                </el-form-item>

                <el-switch
                    v-if="this.from === 'catalog'"
                    v-model="sync_product"
                    active-text="Synchroniser immédiatement sur prestashop"
                ></el-switch>
            </div>
        </el-form>
        <el-dialog
            v-loading="modalGalery.loader"
            :title="'Ajout d\'image pour ' + modalGalery.product.name"
            :visible.sync="modalGalery.display"
            append-to-body
            top="1vh"
            width="80%"
        >
            <gallery-selector
                ref="galerySelector"
                v-model="modalGalery.selected"
                :product="modalGalery.product"
                selectable
            ></gallery-selector>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modalGalery.display = false"
                >Fermer</el-button
                >
                <el-button
                    :disabled="!modalGalery.selected.length"
                    type="primary"
                    @click="modalGalerySave()"
                >Sauvegarder</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
import { array_dot, array_get } from '../../utils/array';
import editorConfig from '../../editorConfig';
import * as Sentry from '@sentry/browser';
import { EventBus } from '../../event-bus';
import { filterCascader } from '../filters';
import { calculTauxMarge } from '../../utils/price';

const countries = [
    { name: 'Afghanistan', code: 'AF' },
    { name: 'Åland Islands', code: 'AX' },
    { name: 'Albania', code: 'AL' },
    { name: 'Algeria', code: 'DZ' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'AndorrA', code: 'AD' },
    { name: 'Angola', code: 'AO' },
    { name: 'Anguilla', code: 'AI' },
    { name: 'Antarctica', code: 'AQ' },
    { name: 'Antigua and Barbuda', code: 'AG' },
    { name: 'Argentina', code: 'AR' },
    { name: 'Armenia', code: 'AM' },
    { name: 'Aruba', code: 'AW' },
    { name: 'Australia', code: 'AU' },
    { name: 'Austria', code: 'AT' },
    { name: 'Azerbaijan', code: 'AZ' },
    { name: 'Bahamas', code: 'BS' },
    { name: 'Bahrain', code: 'BH' },
    { name: 'Bangladesh', code: 'BD' },
    { name: 'Barbados', code: 'BB' },
    { name: 'Belarus', code: 'BY' },
    { name: 'Belgium', code: 'BE' },
    { name: 'Belize', code: 'BZ' },
    { name: 'Benin', code: 'BJ' },
    { name: 'Bermuda', code: 'BM' },
    { name: 'Bhutan', code: 'BT' },
    { name: 'Bolivia', code: 'BO' },
    { name: 'Bosnia and Herzegovina', code: 'BA' },
    { name: 'Botswana', code: 'BW' },
    { name: 'Bouvet Island', code: 'BV' },
    { name: 'Brazil', code: 'BR' },
    { name: 'British Indian Ocean Territory', code: 'IO' },
    { name: 'Brunei Darussalam', code: 'BN' },
    { name: 'Bulgaria', code: 'BG' },
    { name: 'Burkina Faso', code: 'BF' },
    { name: 'Burundi', code: 'BI' },
    { name: 'Cambodia', code: 'KH' },
    { name: 'Cameroon', code: 'CM' },
    { name: 'Canada', code: 'CA' },
    { name: 'Cape Verde', code: 'CV' },
    { name: 'Cayman Islands', code: 'KY' },
    { name: 'Central African Republic', code: 'CF' },
    { name: 'Chad', code: 'TD' },
    { name: 'Chile', code: 'CL' },
    { name: 'China', code: 'CN' },
    { name: 'Christmas Island', code: 'CX' },
    { name: 'Cocos (Keeling) Islands', code: 'CC' },
    { name: 'Colombia', code: 'CO' },
    { name: 'Comoros', code: 'KM' },
    { name: 'Congo', code: 'CG' },
    { name: 'Congo, The Democratic Republic of the', code: 'CD' },
    { name: 'Cook Islands', code: 'CK' },
    { name: 'Costa Rica', code: 'CR' },
    { name: 'Cote D"Ivoire', code: 'CI' },
    { name: 'Croatia', code: 'HR' },
    { name: 'Cuba', code: 'CU' },
    { name: 'Cyprus', code: 'CY' },
    { name: 'Czech Republic', code: 'CZ' },
    { name: 'Denmark', code: 'DK' },
    { name: 'Djibouti', code: 'DJ' },
    { name: 'Dominica', code: 'DM' },
    { name: 'Dominican Republic', code: 'DO' },
    { name: 'Ecuador', code: 'EC' },
    { name: 'Egypt', code: 'EG' },
    { name: 'El Salvador', code: 'SV' },
    { name: 'Equatorial Guinea', code: 'GQ' },
    { name: 'Eritrea', code: 'ER' },
    { name: 'Estonia', code: 'EE' },
    { name: 'Ethiopia', code: 'ET' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK' },
    { name: 'Faroe Islands', code: 'FO' },
    { name: 'Fiji', code: 'FJ' },
    { name: 'Finland', code: 'FI' },
    { name: 'France', code: 'FR' },
    { name: 'French Guiana', code: 'GF' },
    { name: 'French Polynesia', code: 'PF' },
    { name: 'French Southern Territories', code: 'TF' },
    { name: 'Gabon', code: 'GA' },
    { name: 'Gambia', code: 'GM' },
    { name: 'Georgia', code: 'GE' },
    { name: 'Germany', code: 'DE' },
    { name: 'Ghana', code: 'GH' },
    { name: 'Gibraltar', code: 'GI' },
    { name: 'Greece', code: 'GR' },
    { name: 'Greenland', code: 'GL' },
    { name: 'Grenada', code: 'GD' },
    { name: 'Guadeloupe', code: 'GP' },
    { name: 'Guam', code: 'GU' },
    { name: 'Guatemala', code: 'GT' },
    { name: 'Guernsey', code: 'GG' },
    { name: 'Guinea', code: 'GN' },
    { name: 'Guinea-Bissau', code: 'GW' },
    { name: 'Guyana', code: 'GY' },
    { name: 'Haiti', code: 'HT' },
    { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
    { name: 'Holy See (Vatican City State)', code: 'VA' },
    { name: 'Honduras', code: 'HN' },
    { name: 'Hong Kong', code: 'HK' },
    { name: 'Hungary', code: 'HU' },
    { name: 'Iceland', code: 'IS' },
    { name: 'India', code: 'IN' },
    { name: 'Indonesia', code: 'ID' },
    { name: 'Iran, Islamic Republic Of', code: 'IR' },
    { name: 'Iraq', code: 'IQ' },
    { name: 'Ireland', code: 'IE' },
    { name: 'Isle of Man', code: 'IM' },
    { name: 'Israel', code: 'IL' },
    { name: 'Italy', code: 'IT' },
    { name: 'Jamaica', code: 'JM' },
    { name: 'Japan', code: 'JP' },
    { name: 'Jersey', code: 'JE' },
    { name: 'Jordan', code: 'JO' },
    { name: 'Kazakhstan', code: 'KZ' },
    { name: 'Kenya', code: 'KE' },
    { name: 'Kiribati', code: 'KI' },
    { name: 'Korea, Democratic People"S Republic of', code: 'KP' },
    { name: 'Korea, Republic of', code: 'KR' },
    { name: 'Kuwait', code: 'KW' },
    { name: 'Kyrgyzstan', code: 'KG' },
    { name: 'Lao People"S Democratic Republic', code: 'LA' },
    { name: 'Latvia', code: 'LV' },
    { name: 'Lebanon', code: 'LB' },
    { name: 'Lesotho', code: 'LS' },
    { name: 'Liberia', code: 'LR' },
    { name: 'Libyan Arab Jamahiriya', code: 'LY' },
    { name: 'Liechtenstein', code: 'LI' },
    { name: 'Lithuania', code: 'LT' },
    { name: 'Luxembourg', code: 'LU' },
    { name: 'Macao', code: 'MO' },
    { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
    { name: 'Madagascar', code: 'MG' },
    { name: 'Malawi', code: 'MW' },
    { name: 'Malaysia', code: 'MY' },
    { name: 'Maldives', code: 'MV' },
    { name: 'Mali', code: 'ML' },
    { name: 'Malta', code: 'MT' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Martinique', code: 'MQ' },
    { name: 'Mauritania', code: 'MR' },
    { name: 'Mauritius', code: 'MU' },
    { name: 'Mayotte', code: 'YT' },
    { name: 'Mexico', code: 'MX' },
    { name: 'Micronesia, Federated States of', code: 'FM' },
    { name: 'Moldova, Republic of', code: 'MD' },
    { name: 'Monaco', code: 'MC' },
    { name: 'Mongolia', code: 'MN' },
    { name: 'Montserrat', code: 'MS' },
    { name: 'Morocco', code: 'MA' },
    { name: 'Mozambique', code: 'MZ' },
    { name: 'Myanmar', code: 'MM' },
    { name: 'Namibia', code: 'NA' },
    { name: 'Nauru', code: 'NR' },
    { name: 'Nepal', code: 'NP' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'Netherlands Antilles', code: 'AN' },
    { name: 'New Caledonia', code: 'NC' },
    { name: 'New Zealand', code: 'NZ' },
    { name: 'Nicaragua', code: 'NI' },
    { name: 'Niger', code: 'NE' },
    { name: 'Nigeria', code: 'NG' },
    { name: 'Niue', code: 'NU' },
    { name: 'Norfolk Island', code: 'NF' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Norway', code: 'NO' },
    { name: 'Oman', code: 'OM' },
    { name: 'Pakistan', code: 'PK' },
    { name: 'Palau', code: 'PW' },
    { name: 'Palestinian Territory, Occupied', code: 'PS' },
    { name: 'Panama', code: 'PA' },
    { name: 'Papua New Guinea', code: 'PG' },
    { name: 'Paraguay', code: 'PY' },
    { name: 'Peru', code: 'PE' },
    { name: 'Philippines', code: 'PH' },
    { name: 'Pitcairn', code: 'PN' },
    { name: 'Poland', code: 'PL' },
    { name: 'Portugal', code: 'PT' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Qatar', code: 'QA' },
    { name: 'Reunion', code: 'RE' },
    { name: 'Romania', code: 'RO' },
    { name: 'Russian Federation', code: 'RU' },
    { name: 'RWANDA', code: 'RW' },
    { name: 'Saint Helena', code: 'SH' },
    { name: 'Saint Kitts and Nevis', code: 'KN' },
    { name: 'Saint Lucia', code: 'LC' },
    { name: 'Saint Pierre and Miquelon', code: 'PM' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC' },
    { name: 'Samoa', code: 'WS' },
    { name: 'San Marino', code: 'SM' },
    { name: 'Sao Tome and Principe', code: 'ST' },
    { name: 'Saudi Arabia', code: 'SA' },
    { name: 'Senegal', code: 'SN' },
    { name: 'Serbia and Montenegro', code: 'CS' },
    { name: 'Seychelles', code: 'SC' },
    { name: 'Sierra Leone', code: 'SL' },
    { name: 'Singapore', code: 'SG' },
    { name: 'Slovakia', code: 'SK' },
    { name: 'Slovenia', code: 'SI' },
    { name: 'Solomon Islands', code: 'SB' },
    { name: 'Somalia', code: 'SO' },
    { name: 'South Africa', code: 'ZA' },
    { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
    { name: 'Spain', code: 'ES' },
    { name: 'Sri Lanka', code: 'LK' },
    { name: 'Sudan', code: 'SD' },
    { name: 'Suriname', code: 'SR' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ' },
    { name: 'Swaziland', code: 'SZ' },
    { name: 'Sweden', code: 'SE' },
    { name: 'Switzerland', code: 'CH' },
    { name: 'Syrian Arab Republic', code: 'SY' },
    { name: 'Taiwan', code: 'TW' },
    { name: 'Tajikistan', code: 'TJ' },
    { name: 'Tanzania, United Republic of', code: 'TZ' },
    { name: 'Thailand', code: 'TH' },
    { name: 'Timor-Leste', code: 'TL' },
    { name: 'Togo', code: 'TG' },
    { name: 'Tokelau', code: 'TK' },
    { name: 'Tonga', code: 'TO' },
    { name: 'Trinidad and Tobago', code: 'TT' },
    { name: 'Tunisia', code: 'TN' },
    { name: 'Turkey', code: 'TR' },
    { name: 'Turkmenistan', code: 'TM' },
    { name: 'Turks and Caicos Islands', code: 'TC' },
    { name: 'Tuvalu', code: 'TV' },
    { name: 'Uganda', code: 'UG' },
    { name: 'Ukraine', code: 'UA' },
    { name: 'United Arab Emirates', code: 'AE' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'United States', code: 'US' },
    { name: 'United States Minor Outlying Islands', code: 'UM' },
    { name: 'Uruguay', code: 'UY' },
    { name: 'Uzbekistan', code: 'UZ' },
    { name: 'Vanuatu', code: 'VU' },
    { name: 'Venezuela', code: 'VE' },
    { name: 'Viet Nam', code: 'VN' },
    { name: 'Virgin Islands, British', code: 'VG' },
    { name: 'Virgin Islands, U.S.', code: 'VI' },
    { name: 'Wallis and Futuna', code: 'WF' },
    { name: 'Western Sahara', code: 'EH' },
    { name: 'Yemen', code: 'YE' },
    { name: 'Zambia', code: 'ZM' },
    { name: 'Zimbabwe', code: 'ZW' }
];

export default {
    components: {
        draggable
    },
    data() {
        return {
            countries: countries,
            loader: false,
            activeTab: 'general',
            generalHasError: false,
            associateHasError: false,
            seoHasError: false,
            useNewDescription: false,
            sync_product: false,
            collapsFeature: [],
            brandsOptions: [],
            categoriesOptions: [],
            manufacturersOptions: [],
            conditionOptions: [
                {
                    label: 'Nouveau',
                    value: 'new'
                },
                {
                    label: 'Utilisé',
                    value: 'used'
                },
                {
                    label: 'Reconditionné',
                    value: 'refurbished'
                }
            ],
            editorConfig: editorConfig,
            editor: {
                options: {},
                content: null
                /* quill options */
            },
            reaproOptions: [
                {
                    label: 'Dispo à la vente',
                    value: 'available'
                },
                {
                    label: 'Interdire les commandes',
                    value: 'disable_order'
                }
            ],
            rules: {
                designation: [
                    {
                        required: true,
                        message: 'Veuillez renseignez une désignation',
                        trigger: 'blur'
                    }
                ],
                categories: [
                    {
                        required: true,
                        message: 'Veuillez choisir une catégorie',
                        trigger: 'blur'
                    }
                ],
                brand_id: [
                    {
                        required: true,
                        message: 'Veuillez choisir une marque',
                        trigger: 'blur'
                    }
                ],
                /*
                meta_desc: [
                    {
                        required: true,
                        message: 'Veuillez renseigner une meta description',
                        trigger: 'blur'
                    }
                ],
                short_desc: [
                    {
                        required: true,
                        message: 'Veuillez renseigner une description courte',
                        trigger: 'blur'
                    }
                ],*/
                external_ref: [
                    {
                        required: true,
                        message:
                            'Veuillez renseigner une référence fournisseur',
                        trigger: 'blur'
                    }
                ],
                /*
                motocloud_ref: [
                    {
                        required: true,
                        message: 'Veuillez renseigner une référence motocloud',
                        trigger: 'blur'
                    }
                ],
                */
                mf_prefixe: [
                    {
                        required: true,
                        message: 'Veuillez renseigner un préfixe fournisseur',
                        trigger: 'blur'
                    },
                    {
                        min: 3,
                        max: 3,
                        message:
                            'Le préfixe fournisseur doit se composer de 3 caractères',
                        trigger: 'blur'
                    }
                ],
                mf_price_public: [
                    {
                        required: true,
                        message: 'Veuillez renseigner un prix',
                        trigger: 'blur'
                    }
                ],
                meta_title: [
                    {
                        required: true,
                        message: 'Veuillez renseigner un titre SEO',
                        trigger: 'blur'
                    }
                ],
                // technical_desc: [
                //     { required: true, message: 'Veuillez renseigner une description technique', trigger: 'blur' }
                // ],
                desc: [
                    {
                        required: true,
                        message: 'Veuillez renseigner une description',
                        trigger: 'blur'
                    }
                ],
                hs_code: [
                    {
                        required: true,
                        message: 'Veuillez renseigner le HS CODE',
                        trigger: 'blur'
                    }
                ],
                country_origin: [
                    {
                        required: true,
                        message: 'Veuillez renseigner le Pays d\'origine',
                        trigger: 'blur'
                    }
                ]
            },
            modalGalery: {
                display: false,
                product: {},
                selected: [],
                loader: false
            },
            featureOptions: [],
            invalidDescription: false
        };
    },
    props: {
        product: {
            required: 'required'
        },
        fetch: {
            default: false
        },
        productsId: {
            default: () => {
                return [];
            }
        },
        from: {
            default: 'catalog'
        }
    },
    computed: {
        productId() {
            return this.product.id;
        },
        txMarge() {
            return calculTauxMarge(this.product);
        },
        mf_public_price_ttc() {
            return ((this.product.mf_price_public || 0) * 1.2).toFixed(2);
        },
        price_speedway_ttc() {
            return ((this.product.price_speedway || 0) * 1.2).toFixed(2);
        },
        nextId() {
            var indexCurrent = this.productsId.indexOf(this.product.id);
            if (indexCurrent != -1) {
                var nextIndex = indexCurrent + 1;
                if (this.productsId[nextIndex]) {
                    return this.productsId[nextIndex];
                }
            }
            return null;
        },
        user() {
            return this.$store.getters['app/user'];
        },
        productDescription() {
            return this.product.description;
        },
        isCasque() {
            return this.product.types_product_id.includes(118); // Featue Value Casque
        },
        volumetricWeight() {
            if (
                this.product.width > 0 &&
                this.product.height > 0 &&
                this.product.depth > 0
            ) {
                return (
                    (this.product.width *
                        this.product.height *
                        this.product.depth) /
                    5000
                );
            }

            return 0;
        },
        calculatedWeightKg() {
            if (this.product.weight > 0) {
                return this.product.weight / 1000;
            }

            return 0;
        },
        developpeColissimi() {
            return (
                this.product.width + this.product.height + this.product.depth
            );
        },
        developpeChronopost() {
            return (
                this.product.width +
                2 * this.product.height +
                2 * this.product.depth
            );
        }
    },
    watch: {
        productId(newV, oldV) {
            if (this.product.review_errors && this.from == 'review') {
                this.activeTab = 'warning';
            } else {
                this.activeTab = 'general';
            }
            this.checkUseNewDesc();
            this.sync_product = false;
            if (this.fetch) {
                this.getDatas();
            }
        },
        productDescription(newV, oldV) {
            this.checkDescription(newV);
        }
    },
    mounted() {
        if (this.fetch) {
            this.getDatas();
        }
        axios.get('/brands').then((r) => {
            this.brandsOptions = r.data.data;
            this.copyValue('name');
        });
        axios
            .get('/categories', { params: { onlyActivated: true } })
            .then((r) => {
                this.categoriesOptions = r.data.data;
            });
        axios.get('/manufacturers').then((r) => {
            this.manufacturersOptions = r.data.data;
        });

        this.checkUseNewDesc();

        EventBus.$on('checkUseNewDesc', () => {
            this.checkUseNewDesc();
        });
        if (this.product.review_errors && this.from == 'review') {
            this.activeTab = 'warning';
        }
    },
    methods: {
        checkUseNewDesc() {
            let hasTitleDescription = false;
            if (this.product.string_technical_desc) {
                hasTitleDescription = this.product.string_technical_desc.match(
                    /\[titre\]/
                )
                    ? true
                    : false;
            }
            if (
                this.product.titleDescriptions.length &&
                (hasTitleDescription ||
                    (!this.product.string_technical_desc &&
                        !this.product.description))
            ) {
                this.$nextTick(function() {
                    this.useNewDescription = true;
                });
            } else {
                this.$nextTick(function() {
                    this.useNewDescription = false;
                });
            }
        },
        brandChange() {
            this.copyValue('name');
        },
        copyValue(field) {
            switch (field) {
                case 'name':
                    let words = this.product[field].split(' ');
                    words = words.filter((word) => {
                        return word.length > 0;
                    });
                    let designation = words
                        .map((word) => {
                            return word[0].toUpperCase() + word.substring(1);
                        })
                        .join(' ');

                    this.product[field] = designation;
                    let forceSync = false;
                    if (!this.product.syncronized_at) {
                        forceSync = true;
                    }
                    if (forceSync || !this.product.meta_title) {
                        this.product.meta_title = this.product[field];
                    }
                    if (forceSync || !this.product.meta_desc) {
                        let brand = this.brandsOptions.find(
                            (v) => v.id == this.product.brand_id
                        );
                        let append = '';
                        if (brand) {
                            append =
                                '. Tous les produits ' +
                                brand.name +
                                ' sont disponibles sur Speedway.fr au meilleur prix. Livraison et retour gratuits*.';
                        }
                        this.product.meta_desc = this.product[field] + append;
                    }
                    break;
                default:
                    break;
            }
        },
        checkDescription(string) {
            this.invalidDescription = false;
            return;
            let html = document.createElement('html');
            html.innerHTML = string;
            let baliseStyles = html.querySelectorAll('[style]');
            let baliseClass = html.querySelectorAll('[class]');
            if (baliseStyles.length || baliseClass.length) {
                this.invalidDescription = true;
            }
            return this.invalidDescription;
        },
        removeTitle(index, indexV) {
            this.product.titleDescriptions[index].values.splice(indexV, 1);
        },
        addTitle(index) {
            let value = this.product.titleDescriptions[index].to_add;
            if (!value) {
                return;
            }
            this.product.titleDescriptions[index].values.push(value);
            this.product.titleDescriptions[index].to_add = null;
        },
        insertInTitleDescription(index, sentence) {
            this.product.titleDescriptions[index].to_add =
                (this.product.titleDescriptions[index].to_add ?? '') + sentence;
        },
        getDatas() {
            /*this.loader = true;
            axios.get('products/'+ this.productId).then((r)=>{
                this.$store.dispatch('products/updateInList', {
                    id: this.product.id,
                    data: r.data.data
                });
                this.loader = false;
            })*/
        },
        generateSlug() {
            axios
                .post('/products/slug', { name: this.product.name })
                .then((r) => {
                    this.product.slug = r.data.slug;
                });
        },
        updateProduct(next, rest = false) {
            EventBus.$emit('tooggle-summernote');
            this.removeErrorOnTab();
            this.$refs.productForm.validate((valid, errors) => {
                this.validateForm(errors);
                if (valid && !this.checkDescription(this.product.description)) {
                    var catId =
                        this.product.categories[
                        this.product.categories.length - 1
                            ];
                    this.product.category_id = catId;
                    /*
                    if(this.product.date_dispo_fourn){
                        this.product.date_dispo_fourn = this.product.date_dispo_fourn.substr(0,10);
                    }
                    */
                    if (this.product.date_new) {
                        this.product.date_new = this.product.date_new.substr(
                            0,
                            10
                        );
                    }
                    axios
                        .post(
                            '/products/' +
                            this.product.id +
                            '?from=' +
                            this.from,
                            {
                                data: this.product,
                                sync: this.sync_product
                            }
                        )
                        .then((r) => {
                            this.$message({
                                message: 'Produit mis à jour.',
                                type: 'success'
                            });
                            /*
                            this.$store.dispatch('products/updateInList', {
                                id: this.product.id,
                                data: r.data.data
                            });
                            */

                            //this.product = new Product(r.data.data);

                            this.$emit('update:product', r.data.data);

                            //this.$refs.productForm.resetFields();
                            this.$emit('update-product', {
                                product: r.data.data,
                                rest
                            });
                            if (next && this.nextId) {
                                var id = this.nextId;
                                this.$emit('edit-next', id);
                            }

                            this.activeTab = 'general';
                        })
                        .catch((e) => {
                            if (!e.response) {
                                if (process.env.NODE_ENV == 'production') {
                                    Sentry.captureMessage('Error edit product');
                                    Sentry.captureException(e);
                                } else {
                                    console.error(e);
                                }
                            }
                            if (e.response && e.response.status == 422) {
                                this.$alert(
                                    this.buildErrorHtml(e.response.data.errors),
                                    'Erreur lors de la mise à jour.',
                                    {
                                        confirmButtonText: 'OK',
                                        dangerouslyUseHTMLString: true
                                    }
                                );
                            } else {
                                let errorMessage = '';
                                if (
                                    e.response &&
                                    e.response.data &&
                                    e.response.data.message
                                ) {
                                    errorMessage = e.response.data.message;
                                } else {
                                    errorMessage = e.toString();
                                }
                                this.$alert(
                                    '' +
                                    '<div class="alert alert-danger">' +
                                    '<strong>Le produit n\'a pas pu être sauvegarder</strong>' +
                                    '<p class="mt-3">Détail technique : </p>' +
                                    '<code>' +
                                    e.toString() +
                                    ' </code>' +
                                    '<code>' +
                                    errorMessage +
                                    ' </code>' +
                                    '</div>',
                                    'Erreur lors de la mise à jour.',
                                    {
                                        confirmButtonText: 'OK',
                                        dangerouslyUseHTMLString: true
                                    }
                                );
                            }
                        })
                        .then(() => {
                        });
                } else {
                    this.$message({
                        message: 'Veuillez corriger les erreurs.',
                        type: 'warning'
                    });
                }
            });
        },
        buildErrorHtml(errors) {
            if (typeof errors === 'string') {
                return '<div class="alert alert-danger">' + errors + '</div>';
            }
            let html = '<div class="alert alert-danger"><ul>';
            for (let key in errors) {
                html += '<li>' + errors[key][0] + '</li>';
            }
            html += '</ul></div>';
            return html;
        },
        deleteProduct() {
            this.$confirm(
                'Êtes-vous sûr de le supprimer uniquement du PIM  ?',
                'Attention',
                {
                    confirmButtonText: 'Oui',
                    cancelButtonText: 'Annuler',
                    type: 'warning'
                }
            )
                .then(() => {
                    axios
                        .delete('/products/' + this.product.id, {
                            data: this.product
                        })
                        .then((r) => {
                            this.$message({
                                message: r.data.message,
                                type: 'success'
                            });
                            this.$emit('delete-product', this.product.id);
                        })
                        .catch((e) => {
                            if (e.response.status == 422) {
                                this.$message.error(e.response.data.errors);
                            } else {
                                this.$message.error(
                                    'Erreur lors de la suppression.'
                                );
                            }
                        })
                        .then(() => {
                        });
                })
                .catch(() => {
                });
        },
        updateProductInModal(data) {
            this.product = data;
        },
        openGalery(product) {
            this.modalGalery.display = true;
            this.modalGalery.product = Object.assign({}, product);
            this.modalGalery.selected = [];
            if (this.$refs.galerySelector) this.$refs.galerySelector.refresh();
        },
        modalGalerySave() {
            this.modalGalery.loader = true;
            axios
                .post('/products/' + this.modalGalery.product.id, {
                    medias: this.modalGalery.selected,
                    mode: 'gallery'
                })
                .then((r) => {
                    this.updateProductInModal(r.data.data);
                    this.modalGalery.display = false;
                })
                .catch(() => {
                })
                .then(() => {
                    this.modalGalery.loader = false;
                });
        },
        validateForm(errors) {
            var tabs = [
                {
                    name: 'general',
                    fields: [
                        'name',
                        'short_desc',
                        'description',
                        'mf_price_public'
                    ]
                },
                {
                    name: 'associate',
                    fields: [
                        'category_id',
                        'brand_id',
                        'external_ref',
                        'motocloud_ref',
                        'mf_prefixe'
                    ]
                },
                {
                    name: 'seo',
                    fields: ['meta_desc', 'meta_title']
                },
                {
                    name: 'logistics',
                    fields: ['hs_code', 'country_origin']
                }
            ];

            if (this.useNewDescription) {
                let indexDescription = tabs[0].fields.indexOf('description');
                delete tabs[0].fields[indexDescription];
                tabs[0].fields.push('description_detailed');
            }

            for (let error in errors) {
                tabs.forEach((tab) => {
                    if (tab.fields.indexOf(error) != -1) {
                        if (tab.name == 'general') {
                            this.generalHasError = true;
                        } else if (tab.name == 'associate') {
                            this.associateHasError = true;
                        } else if (tab.name == 'seo') {
                            this.seoHasError = true;
                        }
                    }
                });
            }

            if (this.generalHasError) {
                this.addErrorOnTab('general');
            }

            if (this.associateHasError) {
                this.addErrorOnTab('associate');
            }
            if (this.seoHasError) {
                this.addErrorOnTab('seo');
            }
        },
        addErrorOnTab(name) {
            var id_tab = document
                .querySelector('div[data-tabs=' + name + ']')
                .parentElement.getAttribute('aria-labelledby');
            document
                .querySelector('#' + id_tab)
                .setAttribute('data-error', true);
        },
        removeErrorOnTab() {
            this.generalHasError = false;
            this.associateHasError = false;
            this.seoHasError = false;
            var tabs = document.querySelectorAll('.el-tabs__item');
            tabs.forEach((tab) => {
                tab.removeAttribute('data-error');
            });
        },
        variationAdded({ variation, productId }) {
            this.product.variationsCount += 1;
            this.$store.dispatch('products/updateInList', {
                id: productId,
                data: this.product
            });
        },
        variationRemoved({ variation, productId }) {
            this.product.variationsCount -= 1;
            this.$store.dispatch('products/updateInList', {
                id: productId,
                data: this.product
            });
        },
        getFeatureSelectedCount(feature) {
            return this.product.featuresIds.filter(
                (v) => feature.children.filter((r) => r.value == v).length
            ).length;
        },
        findCategory(categoryId) {
            var categoriesOptions = this.categoriesOptions.slice(0);
            var ar = array_dot(categoriesOptions);
            var category = null;
            for (var key in ar) {
                if (key.match(/\.id$/) && ar[key] == categoryId) {
                    category = array_get(
                        categoriesOptions,
                        key.replace(/\.id$/, '')
                    );
                }
            }
            return category;
        },
        addTagCategory() {
            if (!this.product.category_secondary.length) {
                return;
            }

            var categoryId =
                this.product.category_secondary[
                this.product.category_secondary.length - 1
                    ];
            var category = Object.assign({}, this.findCategory(categoryId));
            var index = this.product.categories_secondary.findIndex(
                (v) => v.id == category.id
            );

            if (index == -1) {
                this.product.categories_secondary.push(category);
            }
            this.product.category_secondary = [];
        },
        removeTagCategory(category) {
            var index = this.product.categories_secondary.findIndex(
                (v) => v.id == category.id
            );
            if (index != -1) {
                this.product.categories_secondary.splice(index, 1);
            }
        },
        filterCascader(node, keyword) {
            return filterCascader(node, keyword);
        },
        addCasqueDescriptionSentence(prop) {
            this.product[prop] =
                (this.product[prop] ?? '') +
                '<br>Attention, ce casque est livré avec une visière incolore.';
        }
    }
};
</script>
<style lang="scss">
.edit-product {
    .activity-last-updated {
        margin-bottom: 10px;
    }

    .el-form--label-top {
        .el-form-item__label {
            line-height: normal;
        }
    }

    .link {
        cursor: pointer;

        &:hover {
            color: #409eff;
        }
    }

    div[data-error] {
        color: #f56c6c;
        position: relative;

        &:before {
            content: '*';
        }
    }

    .features-list {
        height: 50vh;
        overflow-y: auto;
        overflow-x: none;
    }

    .ctn-limit-height {
        height: 70vh;
        overflow-y: auto;
        overflow-x: hidden;
    }

    [aria-controls='pane-warning'] {
        color: #f56c6c;
    }
}
</style>
